import { useRef } from 'react';
import { isEqual } from 'lodash';
import { useFormContext } from '@/context/FormContext';
import parseFieldKey from './parseFieldKey';

type Props = {
  aiAgent: { fieldData: string[], aiModel: string };
};

const useInputFieldKeys = ({ aiAgent }: Props): string[] => {
  const {
    formMethods,
    fieldsByKey,
    fieldsById,
  } = useFormContext();
  const storedFieldKeys = useRef<string[]>([]);

  const dependentFieldKeys = aiAgent.fieldData
    ? aiAgent.fieldData.flatMap((fieldKey) => {
      const field = fieldsByKey[fieldKey];
      if (field?.listFieldTemplateId) {
        const listField = fieldsById[field.listFieldTemplateId];
        if (listField) {
          const listFieldValues = formMethods.getValues()[listField.key];
          if (!listFieldValues || !Array.isArray(listFieldValues) || listFieldValues?.length === 0) {
            return [];
          }
          return listFieldValues.map((__, index) => `${listField.key}[${index}].${fieldKey}`);
        }
      }
      return fieldKey;
    })
    : [];

  if (aiAgent.aiModel === 'boxIndex') {
    dependentFieldKeys.forEach((key) => {
      const values = parseFieldKey(key);
      if (values.listFieldKey) {
        dependentFieldKeys.push(`${values.listFieldKey}[${values.rowIndex}]._associatedWithId`);
      }
    });
  }

  if (!isEqual(dependentFieldKeys, storedFieldKeys.current)) {
    storedFieldKeys.current = dependentFieldKeys;
  }

  return storedFieldKeys.current;
};

export default useInputFieldKeys;